import * as React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { clearBanner } from 'shared/actions/ui/actions'
import { Snackbars } from 'shared/components/Snackbars/Snackbars'
import { InlineSpinner } from 'shared/components/Spinner'

import { ScrollToTop } from './components/ScrollToTop/ScrollToTop'
import { StripeTosModal } from './components/StripeTos/StripeTosModal'
import { Consultant } from './pages/Consultant/Consultant'
import { Routes } from './Routes'

export const AppContainer = ({ children }: { children?: React.ReactNode }) => {
  const dispatch = useDispatch()

  function renderSuspenseFallback() {
    return <InlineSpinner mt={5} mb={5} />
  }

  return (
    <>
      <React.Suspense fallback={renderSuspenseFallback()}>{children ? children : <Routes />}</React.Suspense>
      <Snackbars onClose={() => dispatch(clearBanner())} useSelector={useSelector} />
      <ScrollToTop />
      <StripeTosModal />
      <Consultant />
      {/* Disable animations in integration tests */}
      {process.env.REACT_APP_INTEGRATION === 'true' && <style>{`* { transition: none !important; }`}</style>}
    </>
  )
}
